import {
  Cog6ToothIcon,
  // HomeIcon,
  UsersIcon,
  UserGroupIcon,
  DocumentTextIcon,
  ClipboardDocumentListIcon,
  // QueueListIcon,
  ClipboardDocumentCheckIcon,
  // TableCellsIcon,
  FolderIcon,
  // ShieldCheckIcon,
  AdjustmentsHorizontalIcon,
  Squares2X2Icon,
  PlusIcon,
  MagnifyingGlassIcon,
  DocumentIcon,
  // GlobeAltIcon,
  DocumentArrowUpIcon,
  DocumentDuplicateIcon,
  ClockIcon
} from '@heroicons/react/24/outline';

// Import API service
import api from '../services/api';

// Function to fetch custom pages and add them to navigation
export const fetchCustomPagesForNavigation = async () => {
  try {
    console.log('Fetching custom pages from API...');
    const response = await api.get('/custom-pages');
    console.log('API response:', response.data);

    if (response.data.success) {
      const pages = response.data.data.map(page => ({
        name: page.menuName || page.name,
        path: `custom-page-submissions/${page._id}`,
        element: 'CustomPageSubmissionsTable',
        requiredPermission: 'View Custom Page Submissions',
        customPageId: page._id,
        category: page.menuCategory || 'General'
      }));
      console.log('Mapped pages:', pages);
      return pages;
    }
  } catch (error) {
    console.error('Error fetching custom pages for navigation:', error);
  }
  return [];
};

// Base navigation structure
export const baseNavigation = [
  {
    name: 'New',
    href: '#',
    icon: 'M12 4v16m8-8H4',
    iconComponent: PlusIcon,
    requiredPermissions: ['Create Master Data', 'Create Task', 'Create Invoice', 'Create Form', 'Create Trademark Applications', 'Create Time Logs', 'View Custom Pages', 'Create Custom Page Submission'],
    element: null,
    children: [
      {
        name: 'Master Data',
        path: 'new/master-data',
        element: 'MasterDataForm',
        requiredPermission: 'Create Master Data',
        iconComponent: FolderIcon
      },
      {
        name: 'Task',
        path: 'new/task',
        element: 'CreateTask',
        requiredPermission: 'Create Task',
        iconComponent: ClipboardDocumentListIcon
      },
      {
        name: 'Invoice',
        path: 'new/invoice',
        element: 'InvoiceForm',
        requiredPermission: 'Create Invoice',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Forms',
        path: 'new/forms',
        element: 'FormsSelection',
        requiredPermission: 'Create Form',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Trademark Registration',
        path: 'new/trademark-application',
        element: 'TrademarkApplication',
        requiredPermission: 'Create Trademark Applications',
        iconComponent: DocumentIcon
      },
      {
        name: 'New Court Cases',
        path: 'new/court-cases',
        element: 'NewCourtCases',
        requiredPermission: 'Create Court Cases',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'India Post',
        path: 'new/india-post',
        element: 'IndiaPost',
        requiredPermission: 'Create India Post',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Time Log',
        path: 'new/time-log',
        element: 'TimeLogForm',
        requiredPermission: 'Create Time Logs',
        iconComponent: ClockIcon
      }
    ]
  },
  {
    name: 'API Data',
    href: '#',
    element: null,
    icon: 'CloudArrowUpIcon',
    requiredPermissions: ['View Admin Settings'],
    children: [
      {
        name: 'Trademark Portfolio',
        path: '/api-data/trademark-portfolio',
        element: 'TrademarkPortfolio',
        requiredPermission: 'View Admin Settings'
      },
      {
        name: 'Trademark Changes',
        path: '/api-data/trademark-changes-list',
        element: 'TrademarkChangesList',
        requiredPermission: 'View Admin Settings'
      },
      {
        name: 'Cited Marks',
        path: '/api-data/cited-marks',
        element: 'CitedMarks',
        requiredPermission: 'View Admin Settings'
      },
      {
        name: 'Opposition Changes',
        path: '/api-data/opposition-changes',
        element: 'OppositionChanges',
        requiredPermission: 'View Admin Settings'
      },
      {
        name: 'Hearings',
        path: '/api-data/hearings',
        element: 'Hearings',
        requiredPermission: 'View Admin Settings'
      },
      {
        name: 'Compliances',
        path: '/api-data/compliances',
        element: 'Compliances',
        requiredPermission: 'View Admin Settings'
      },
      {
        name: 'Trademark Import',
        path: '/api-data/trademark-import',
        element: 'TrademarkImport',
        requiredPermission: 'View Admin Settings'
      },
      {
        name: 'Name Check',
        path: '/name-check',
        element: 'NameCheck',
        requiredPermission: 'View Admin Settings'
      }
    ]
  },
  {
    name: 'View & Search',
    href: '#',
    icon: 'M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z',
    iconComponent: MagnifyingGlassIcon,
    requiredPermissions: ['View Master Data', 'View Form Submissions', 'View Tasks', 'View Invoices', 'View Custom Page Submissions'],
    element: null,
    children: [
      {
        name: 'Master Data',
        path: 'master-data',
        element: 'MasterDataList',
        requiredPermission: 'View Master Data',
        iconComponent: FolderIcon
      },
      {
        name: 'Form Submissions',
        path: 'form-submissions',
        element: 'FormSubmissions',
        requiredPermission: 'View Form Submissions',
        iconComponent: ClipboardDocumentCheckIcon
      },
      {
        name: 'Tasks',
        path: 'tasks',
        element: 'TaskList',
        requiredPermission: 'View Tasks',
        iconComponent: ClipboardDocumentListIcon
      },
      {
        name: 'Invoices',
        path: 'invoices',
        element: 'InvoiceList',
        requiredPermission: 'View Invoices',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'DOCX Editor',
        path: 'docx-editor',
        element: 'DocxEditor',
        requiredPermission: 'Create Documents',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Trademark Applications',
        path: 'trademark-applications',
        element: 'TrademarkApplicationsList',
        requiredPermission: 'View Trademark Applications',
        iconComponent: DocumentIcon
      },
      {
        name: 'TM-A Filing Scheduler',
        path: 'trademark-filing-queue',
        element: 'FilingQueue',
        requiredPermission: 'View Trademark Applications',
        iconComponent: ClockIcon
      }
    ]
  },
  {
    name: 'Deadlines',
    href: '/forms-and-tasks',
    icon: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z',
    iconComponent: Squares2X2Icon,
    requiredPermissions: ['View Deadlines'],
    element: 'FormsAndTasks'
  },
  {
    name: 'Other Applications',
    requiredPermission: 'View Custom Page Submissions',
    iconComponent: DocumentTextIcon,
    children: []
  },
  {
    name: 'Admin',
    href: '/admin',
    icon: 'M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z',
    iconComponent: Cog6ToothIcon,
    requiredPermissions: [
      'View Users',
      'View Groups',
      'View Client Types',
      'View Products',
      'View Upload Fields',
      'View Verification Types',
      'View Email Gateways',
      'View Admin Settings',
      'View Custom Page Submissions',
      'View Invoice Settings',
      'View Trademark Settings',
      'View Payment Settings',
      'View Forms',
      'View Form Settings',
      'View Form Categories',
      'View Email Templates',
      'View Document Templates',
      'View Custom Pages',
      'View Custom Page Documents',
      'Generate Documents'
    ],
    element: 'Admin',
    children: [
      {
        name: 'Document Generation',
        path: 'document-generation',
        element: 'DocumentGeneration',
        requiredPermission: 'Generate Documents',
        iconComponent: DocumentArrowUpIcon
      },
      {
        name: 'Forms',
        path: 'forms',
        element: 'FormsWithCategories',
        requiredPermission: 'View Forms',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Admin Settings',
        path: 'settings',
        element: 'AdminSettings',
        requiredPermissions: [
          'View Admin Settings',
          'View Custom Pages',
          'View Payment Settings',
          'View Client Types',
          'View Form Categories',
          'View Custom Page Submissions',
          'View Products',
          'View Upload Fields',
          'View Verification Types',
          'View Email Gateways',
          'View Email Templates',
          'View Invoice Settings',
          'View Blocks',
          'View Custom Page Documents',
          'View Document Templates'
        ],
        iconComponent: AdjustmentsHorizontalIcon,
        children: [
          {
            name: 'Blocks',
            path: 'blocks',
            element: 'Blocks',
            requiredPermission: 'View Blocks'
          },
          {
            name: 'Client Types',
            path: 'client-types',
            element: 'ClientTypes',
            requiredPermission: 'View Client Types'
          },
          {
            name: 'Products',
            path: 'products',
            element: 'ProductManagement',
            requiredPermission: 'View Products'
          },
          {
            name: 'Upload Fields',
            path: 'upload-fields',
            element: 'UploadFields',
            requiredPermission: 'View Upload Fields'
          },
          {
            name: 'Verification Types',
            path: 'verification-types',
            element: 'VerificationTypes',
            requiredPermission: 'View Verification Types'
          },
          {
            name: 'Email Gateways',
            path: 'email-gateways',
            element: 'EmailGateways',
            requiredPermission: 'View Email Gateways'
          },
          {
            name: 'Form Categories',
            path: 'form-categories',
            element: 'FormCategories',
            requiredPermission: 'View Form Categories'
          },
          {
            name: 'Email Templates',
            path: 'email-templates',
            element: 'EmailTemplates',
            requiredPermission: 'View Email Templates'
          },
          {
            name: 'Invoice Settings',
            path: 'invoice-settings',
            element: 'InvoiceSettings',
            requiredPermission: 'View Invoice Settings'
          },
          {
            name: 'Payment Settings',
            path: 'payment-settings',
            element: 'PaymentSettings',
            requiredPermission: 'View Payment Settings'
          },
          {
            name: 'Prefilling Settings',
            path: 'prefilling-settings',
            element: 'PrefillingSettings',
            requiredPermission: 'View Admin Settings'
          },
          {
            name: 'Generate POA Document',
            path: 'poa-document-generator',
            element: 'PoaDocumentGenerator',
            requiredPermission: 'View Admin Settings'
          },
          {
            name: 'Admin Document Generation',
            path: 'admin-document-generation',
            element: 'AdminDocumentGeneration',
            requiredPermission: 'View Document Templates',
            iconComponent: DocumentTextIcon,
            children: [
              {
                name: 'Templates',
                path: 'templates',
                element: 'AdminDocumentGeneration',
                requiredPermission: 'View Document Templates'
              },
              {
                name: 'New Template',
                path: 'templates/new',
                element: 'TemplateUpload',
                requiredPermission: 'Create Document Templates'
              },
              {
                name: 'Generate Documents',
                path: 'generate',
                element: 'GenerateDocuments',
                requiredPermission: 'Generate Documents'
              }
            ]
          },
          {
            name: 'API Integration Settings',
            path: 'api-integration-settings',
            element: 'ApiIntegrationSettings',
            requiredPermission: 'View Admin Settings'
          }
        ]
      },
      {
        name: 'Other Applications',
        requiredPermission: 'View Custom Page Submissions',
        iconComponent: DocumentTextIcon,
        children: [
          {
            name: 'Admin Document Generation',
            path: 'admin-document-generation',
            element: 'AdminDocumentGeneration',
            requiredPermission: 'View Document Templates',
            iconComponent: DocumentDuplicateIcon
          }
        ]
      },
      { 
        name: 'Users',
        path: 'users',
        element: 'Users',
        requiredPermission: 'View Users',
        iconComponent: UsersIcon
      },
      {
        name: 'Groups',
        path: 'groups',
        element: 'Groups',
        requiredPermission: 'View Groups',
        iconComponent: UserGroupIcon
      },
      {
        name: 'Custom Pages',
        path: 'settings/custom-pages',
        element: 'CustomPages',
        requiredPermission: 'View Custom Pages',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Custom Documents',
        path: 'settings/custom-documents',
        element: 'CustomDocuments',
        requiredPermission: 'View Custom Page Documents',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Trademark Settings',
        path: 'trademark-settings',
        element: 'TrademarkSettings',
        requiredPermission: 'View Trademark Settings',
        iconComponent: Cog6ToothIcon
      },
      {
        name: 'Admin Document Generation',
        path: 'admin-document-generation',
        element: 'AdminDocumentGeneration',
        requiredPermission: 'View Document Templates',
        iconComponent: DocumentTextIcon
      }
    ]
  }
];

// Function to build complete navigation with custom pages
export const buildNavigation = async () => {
  const navigation = JSON.parse(JSON.stringify(baseNavigation)); // Deep clone

  try {
    console.log('Building navigation with custom pages...');

    // Fetch custom pages
    const customPages = await fetchCustomPagesForNavigation();
    console.log('Fetched custom pages:', customPages);
    console.log('Number of custom pages:', customPages.length);

    // Group custom pages by category
    const groupedPages = {};
    const groupedNewPages = {}; // For "New" menu - new submission pages
    customPages.forEach(page => {
      console.log('Processing page:', page);
      const category = page.category;
      if (!groupedPages[category]) {
        groupedPages[category] = [];
      }
      if (!groupedNewPages[category]) {
        groupedNewPages[category] = [];
      }
      // Create a submission link for each page (for Other Applications menu)
      const submissionPage = {
        name: `${page.name} Submissions`,
        path: `custom-page-submissions/${page.customPageId}`,
        element: 'CustomPageSubmissionsTable',
        requiredPermission: 'View Custom Page Submissions',
        pageId: page.customPageId,
        pageTitle: page.name
      };
      console.log('Created submission page:', submissionPage);
      groupedPages[category].push(submissionPage);

      // Create a new submission link for each page (for New menu)
      const newSubmissionPage = {
        name: page.name,
        path: `custom-page/${page.customPageId}`,
        element: 'CustomPageRenderer',
        requiredPermission: 'Create Custom Page Submission',
        pageId: page.customPageId,
        pageTitle: page.name,
        customPageId: page.customPageId
      };
      console.log('Created new submission page:', newSubmissionPage);
      groupedNewPages[category].push(newSubmissionPage);
    });

    console.log('Grouped submission pages:', groupedPages);
    console.log('Grouped new submission pages:', groupedNewPages);

    // Find the Other Applications menu item (now at top level)
    const otherApplicationsMenu = navigation.find(item => item.name === 'Other Applications');

    console.log('Found Other Applications menu:', otherApplicationsMenu);

    if (otherApplicationsMenu) {
      // Store the grouped pages in a way that can be accessed during rendering
      // but don't automatically add them to the menu
      otherApplicationsMenu._groupedPages = groupedPages;
      console.log('Stored grouped submission pages for Other Applications menu');
    } else {
      console.log('Other Applications menu not found!');
    }

    // Find the New menu item
    const newMenu = navigation.find(item => item.name === 'New');

    console.log('Found New menu:', newMenu);

    if (newMenu && Object.keys(groupedNewPages).length > 0) {
      // Create a single "Custom Pages" submenu item with all categories
      const customPagesSubmenu = {
        name: 'Custom Pages',
        type: 'submenu',
        requiredPermission: 'Create Custom Page Submission',
        iconComponent: DocumentTextIcon,
        children: Object.entries(groupedNewPages).map(([category, newSubmissionPages]) => ({
          name: category,
          type: 'category',
          children: newSubmissionPages.map(newSubmissionPage => ({
            name: newSubmissionPage.name,
            path: newSubmissionPage.path,
            element: newSubmissionPage.element,
            requiredPermission: 'Create Custom Page Submission',
            pageId: newSubmissionPage.pageId,
            pageTitle: newSubmissionPage.pageTitle,
            customPageId: newSubmissionPage.customPageId
          }))
        }))
      };
      
      // Add the submenu to the New menu's children
      if (!newMenu.children) {
        newMenu.children = [];
      }
      newMenu.children.push(customPagesSubmenu);
      console.log('Added Custom Pages submenu to New menu');
    } else {
      console.log('New menu not found or no custom pages!');
    }

    // Find the View & Search menu item
    const viewSearchMenu = navigation.find(item => item.name === 'View & Search');

    console.log('Found View & Search menu:', viewSearchMenu);

    if (viewSearchMenu && Object.keys(groupedPages).length > 0) {
      // Create a single "Custom Pages" submenu item with all categories (for submissions)
      const customPagesSubmissionsSubmenu = {
        name: 'Custom Pages',
        type: 'submenu',
        requiredPermission: 'View Custom Page Submissions',
        iconComponent: DocumentTextIcon,
        children: Object.entries(groupedPages).map(([category, submissionPages]) => ({
          name: category,
          type: 'category',
          children: submissionPages.map(submissionPage => ({
            name: submissionPage.name,
            path: submissionPage.path,
            element: submissionPage.element,
            requiredPermission: submissionPage.requiredPermission,
            pageId: submissionPage.pageId,
            pageTitle: submissionPage.pageTitle
          }))
        }))
      };
      
      // Add the submenu to the View & Search menu's children
      if (!viewSearchMenu.children) {
        viewSearchMenu.children = [];
      }
      viewSearchMenu.children.push(customPagesSubmissionsSubmenu);
      console.log('Added Custom Pages submenu to View & Search menu');
    } else {
      console.log('View & Search menu not found or no custom pages!');
    }
  } catch (error) {
    console.error('Error building navigation with custom pages:', error);
  }
  console.log(navigation);
  return navigation;
};

// Export the base navigation for backward compatibility
export const navigation = baseNavigation; 
